import { render } from "./Bill_archive.vue?vue&type=template&id=bcffafa2&ts=true"
import script from "./Bill_archive.vue?vue&type=script&lang=ts"
export * from "./Bill_archive.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__